<template>
  <v-row>
    <v-col cols="12">
      <v-sheet>
        <v-col cols="12">
          <v-lazy
            :options="{
              threshold: .5
            }"
            min-height="200"
            transition="fade-transition"
          >
          
            <showIdeaProjectsStand 
              v-if="!loading && entrepreneurship.window.type_postulations_id===1" 
              :data="entrepreneurship" 
              :logo="customization.idea_project_logo"
              :color="customization.idea_project_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
    
            <showIdeaProjectsSchoolsStand 
              v-if="!loading && entrepreneurship.window.type_postulations_id===2" 
              :data="entrepreneurship" 
              :logo="customization.idea_project_school_logo"
              :color="customization.idea_project_school_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
                  
            <showBusinessModelsStand
              v-if="!loading && entrepreneurship.window.type_postulations_id===3" 
              :data="entrepreneurship" 
              :logo="customization.business_model_logo"
              :color="customization.business_model_color"
              :project_gallery_mode="customization.project_gallery_mode"/>
          </v-lazy>
        </v-col>
      </v-sheet>
    </v-col>

    <v-col cols="12" class="pt-8 d-sm-flex">
      <v-btn
        depressed
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-auto mt-2"
        :to="{ name: 'standsOrganizer'}"
        >
        <v-icon left>
          mdi-arrow-left
        </v-icon>
        Volver
      </v-btn>
      
      <v-spacer />

      <v-btn
        depressed
        color="primary"
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        :to="{ name: 'editStandOrganizer'}"
        >
        <v-icon left>
          mdi-pencil
        </v-icon>
        Editar
      </v-btn>

      <v-btn
        depressed
        :block="$vuetify.breakpoint.xsOnly"
        class="mr-2 mt-2"
        color="primary"
        disabled
        >
        Descargar PDF
      </v-btn>
    </v-col>

    <v-dialog
      v-model="loading"
      overlay
      persistent
      width="300"
      >
      <v-card
        color="primary"
        dark
      >
        <v-card-text>
          <label>Cargando...</label>
          <v-progress-linear
            indeterminate
            color="white"
            class="mb-0"
          ></v-progress-linear>
        </v-card-text>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
  import axios from 'axios'
  import showIdeaProjectsStand from '@/components/stand/preview/showIdeaProjectsStandPreview.vue'
  import showIdeaProjectsSchoolsStand from '@/components/stand/preview/showIdeaProjectsSchoolsStandPreview.vue'
  import showBusinessModelsStand from '@/components/stand/preview/showBusinessModelsStandPreview.vue'

  export default {
    name: 'showStandOrganizer',
    components: { 
      showIdeaProjectsStand,
      showIdeaProjectsSchoolsStand,
      showBusinessModelsStand},
    data: () => ({
      loading:true,
      slug:'',
      edition_id:null,
      edition: null,
      entrepreneurship_id:null,

      entrepreneurship:[],
      customization: []
    }),
    methods:{
      async getWindowOrganizer(){
        await axios.get('organizer/windows/'+this.entrepreneurship_id).then(response =>{
          this.entrepreneurship = response.data.data
          this.entrepreneurship.window.handle_like = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      async getInfoEdition(){
        const url = 'edition/'+ this.edition_id
        await axios.get(url).then(response =>{
          this.edition = response.data.data
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      },

      async getCustomizationProjectGallery(){
        const url = 'edition/customization/'+ this.edition.edition.slug+'/projects-gallery'
        await axios.get(url).then(response =>{
          this.customization = response.data.data
          this.loading = false
        }).catch(error => {
          this.loading = false
          console.log(error);
        })
      }
    },
    created(){
       this.edition_id = this.$route.params.edition_id;
      this.entrepreneurship_id = this.$route.params.entrepreneurship_id;

      // Ejecutamos las dos funciones que devuelven promesas
      Promise.all([
        this.getWindowOrganizer(),
        this.getInfoEdition()
      ]).then(() => {
        // Esto se ejecuta cuando las dos promesas anteriores ya terminaron
        this.getCustomizationProjectGallery();
      }).catch(error => {
        console.error('Error al cargar datos:', error);
      });
    }
  }
</script>
<style>
.images {
  position: fixed;
}
</style>